// Persistenz der Saison-Inlandsflüge einer Reise-Metadaten-Saison

// Bündelt Endpunkte, damit die Karte rein präsentationsnah bleibt
import apiService from '@/core/common/services/api.service';

// Wandelt eine Uhrzeit "HH:mm" in das von .NET als TimeOnly akzeptierte Format "HH:mm:00" um
function toTimeOnly(value) {
  return value ? value + ':00' : value;
}

// Vereinheitlicht Flughafen-Codes zu einem kommaseparierten String
function joinFlughaefen(value) {
  return typeof value === 'string' ? value : value.join();
}

// Löscht einen Inlandsflug der Saison
export function remove(reisekuerzel, gueltigAb, inlandsflugId) {
  return apiService.delete(
    `Reise/${reisekuerzel}/metadata/${gueltigAb}/inlandsflug?inlandsflugId=${inlandsflugId}&overwriteReisetermine=true`
  );
}

// Legt einen neuen Inlandsflug an
export function create(reisekuerzel, gueltigAb, inlandsflug, overwriteReisetermine) {
  const timeOnlyParams = ['spaetesteAnkunft', 'fruehesterAbflug'];
  const body = Object.keys(inlandsflug).reduce((acc, curr) => {
    if (curr === 'isOnlyLocal' || curr === 'id') return acc;
    else if (['zielflughafenIataCode', 'abflughafenIataCode'].includes(curr)) {
      acc[curr] = inlandsflug[curr].join();
    } else if (timeOnlyParams.includes(curr) && inlandsflug[curr]) {
      acc[curr] = inlandsflug[curr] + ':00';
    } else {
      acc[curr] = inlandsflug[curr];
    }
    return acc;
  }, {});
  return apiService.post(
    `/Reise/${reisekuerzel}/metadata/${gueltigAb}/inlandsflug?overwriteReisetermine=${overwriteReisetermine}`,
    body
  );
}

// Aktualisiert einen bestehenden Inlandsflug
export function update(reisekuerzel, gueltigAb, inlandsflug) {
  return apiService.put(
    `Reise/${reisekuerzel}/metadata/${gueltigAb}/inlandsflug?inlandsflugId=${inlandsflug.id}&overwriteReisetermine=true`,
    {
      tag: inlandsflug.tag,
      einkauf: inlandsflug.einkauf,
      fruehesterAbflug: toTimeOnly(inlandsflug.fruehesterAbflug),
      spaetesteAnkunft: toTimeOnly(inlandsflug.spaetesteAnkunft),
      minimaleUmsteigezeit: inlandsflug.minimaleUmsteigezeit,
      zielflughafenIataCode: joinFlughaefen(inlandsflug.zielflughafenIataCode),
      abflughafenIataCode: joinFlughaefen(inlandsflug.abflughafenIataCode),
    }
  );
}
